import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const clientFacilityApi = createApi({
  reducerPath: "clientFacility",
  refetchOnFocus: true,
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
    withCredentials: true
  }),
  endpoints: build => ({
    getFacility: build.query({
      query: id => `/api/ClientFacility/${id}`
    }),
    getNewFacility: build.query({
      query: newFacilityRequest => ({
        url: '/api/ClientFacility/New',
        method: 'POST',
        body: newFacilityRequest
      })
    }),
    getFacilities: build.query({
      query: searchCriteria => ({
        url: '/api/ClientFacility/Search',
        method: 'POST',
        body: searchCriteria
      }),
      providesTags: ['Facilities']
    }),
    addFacility: build.mutation({
      query: facility => ({
        url: '/api/ClientFacility/',
        method: 'POST',
        body: facility
      }),
      invalidatesTags: ['Facilities']
    }),
    saveFacility: build.mutation({
      query: facility => ({
        url: '/api/ClientFacility/',
        method: 'PUT',
        body: facility
      }),
      invalidatesTags: ['Facilities']
    })
  }),
  tagTypes: ['Facilities']
})

export const { useGetFacilityQuery, useGetNewFacilityQuery, useGetFacilitiesQuery, useAddFacilityMutation, useSaveFacilityMutation } = clientFacilityApi
